<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 内容管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">

            <el-table
                    :data="tableData"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="ID" prop="Id" sortable width="65"></el-table-column>
                <el-table-column label="资讯标题" prop="Ntitle" sortable></el-table-column>
                <el-table-column align="center" label="所属分类" prop="menu" sortable></el-table-column>
                <el-table-column align="center" label="发布时间" prop="Ntime"></el-table-column>
                <el-table-column align="center" label="浏览次数" prop="Ncnum"></el-table-column>
                <el-table-column align="center" label="资讯状态" sortable>
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Nstate===0?'danger':(scope.row.Nstate===1?'info':'success')"
                        >{{scope.row.Nstate===0?'屏蔽状态':(scope.row.Nstate===1?'正常显示':'推荐首页')}}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column align="center" label="最近更新" prop="Nupdatetime" sortable width="168"></el-table-column>
                <el-table-column align="center" label="排序编号" prop="Ncorder" sortable></el-table-column>
                <el-table-column align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleEdit(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>
                        <el-button
                                type="text"
                                icon="el-icon-edit"
                                class="red"
                                @click="handleEditContext(scope.$index, scope.row)"
                        >内容
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="searchPage" v-show="show.search">
                共计 【 {{pageTotal}} 】条符合条件的结果
            </div>
            <div class="pagination" v-show="show.page">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框- 内容属性 -->
        <el-dialog :visible.sync="editVisible" title="编辑内容信息" width="50%">
            <el-form :model="form" label-width="100px" ref="form">
                <el-row :gutter="20">
                    <el-col :span="16">
                        <el-form-item label="资讯主标题：">
                            <el-input v-model="form.Ntitle"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="16">
                        <el-form-item label="资讯副标题：">
                            <el-input v-model="form.Nsubtitle"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="内容状态：">
                            <el-select filterable placeholder="请选择" v-model="form.Nstate">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in articleOpt.state">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="分类类型：">
                            <el-select filterable placeholder="请选择" v-model="form.Nptype">
                                <el-option
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        v-for="item in articleOpt.type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="所属目的地：">
                            <el-select placeholder="请选择" v-model="form.Ncity">
                                <el-option :key="item.Id"
                                           :label="item.Cname"
                                           :value="item.Id"
                                           v-for="item in articleOpt.city"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="发表时间：">
                            <el-input v-model="form.Ntime"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="信息来源：">
                            <el-input v-model="form.Nsource"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="信息URL：">
                            <el-input v-model="form.NsourceUrl"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="作者名称：">
                            <el-input v-model="form.Neditor"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="排序编号：">
                            <el-input v-model="form.Ncorder"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="内容简码：">
                            <el-input v-model="form.Nchar"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="浏览次数：">
                            <el-input v-model="form.Ncnum"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="共建次数：">
                            <el-input v-model="form.Nupdatenum"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="分类ID：">
                            <el-input v-model="form.Npid"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="内容摘要：">
                    <el-input
                            maxlength="255"
                            placeholder="请输入内容"
                            rows="4"
                            show-word-limit
                            type="textarea"
                            v-model="form.Nsummary"
                    >
                    </el-input>
                </el-form-item>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="当前图片：">
                            <el-input v-model="form.Nimage" :readonly="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="更换图片：">
                    <el-upload

                            :before-upload="beforeAvatarUpload"
                            :http-request="updateImage"
                            :limit="10"
                            :on-exceed="handleExceed"
                            :on-preview="handlePictureCardPreview"
                            :show-file-list="false"
                            action=""
                            list-type="picture">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button @click="saveEdit" type="primary">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框- 富文本内容 -->
        <el-dialog :visible.sync="editContxtVisible" title="编辑内容信息" width="50%">
            <el-form :model="form" label-width="100px" ref="form">
                    <quill-editor :options="editorOption" ref="myTextEditor" v-model="form.Ndescription"></quill-editor>
            </el-form>
            <span slot="footer">
                <el-button @click="editContxtVisible = false">取 消</el-button>
                <el-button @click="saveEdit" type="primary">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import { quillEditor } from 'vue-quill-editor';

    export default {
        name: 'basetable',
        data() {
            return {
                articleOpt: {
                    menu: [],
                    city: [],
                    state: [{
                        value: 0,
                        label: '屏蔽状态'
                    }, {
                        value: 1,
                        label: '正常显示'
                    }, {
                        value: 2,
                        label: '推荐首页'
                    }],
                    type: [{
                        value: 1,
                        label: '景点'
                    }, {
                        value: 2,
                        label: '美食'
                    }, {
                        value: 3,
                        label: '酒店'
                    }, {
                        value: 4,
                        label: '线路'
                    }, {
                        value: 5,
                        label: '其他'
                    }]

                },
                query: {
                    address: '',
                    name: '',
                    pageIndex: 1,
                    pageSize: 15,
                    sdid: sessionStorage.getItem('ml_cityId'),
                    state: 1
                },

                editorOption: {
                    placeholder: 'THE CONTEXT IS NULL'
                },

                //destCity: { cityId: 17 },
                show: {
                    page: true,
                    search: false
                },
                tableData: [],
                editVisible: false,
                editContxtVisible: false,
              //  addVisible: false,
                pageTotal: 0,
                form: {},
                idx: -1,
                id: -1
            };
        },

        components: {
            quillEditor
        },

        created() {
            this.getArticleData();

        },
        methods: {




            // 资讯内容列表数据
            async getArticleData() {
                const { data: res } = await this.$http.post('admin/articles/initArticleData', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取数据失败，请联系管理员!');
                }
                this.articleOpt.menu = res.menu;
                this.articleOpt.city = res.city;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal || 25;
                this.show.page = true;
                this.$message.success('【内容数据】加载成功!');
            },

            // 编辑资讯属性内容 操作
            handleEdit(index, row) {
                this.idx = index;
                this.form = row;
                this.editVisible = true;
            },

            // 编辑资讯富文本内容 操作
            handleEditContext(index, row) {
                this.idx = index;
                this.form = row;
                this.editContxtVisible = true;
            },

            // 保存资讯属性内容 操作
            async saveEdit() {
                this.editVisible = false;
                this.editContxtVisible = false;
                // this.form['userId'] = localStorage.getItem('ml_userid');
                this.$set(this.tableData, this.idx, this.form);
                const { data: res } = await this.$http.post('/admin/articles/updatArticle', {
                    form: this.form
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，修资讯内容失败，请联系管理员!');
                }
                this.$message.success(res.message);
            },

            onEditorChange({ editor, html, text }) {
                this.content = html;
            },

            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.getArticleData();
            },

            //上传文件
            async updateImage(param) {
                const formData = new FormData();
                formData.append('file', param.file);
                formData.append('id', this.form.Id);
               // formData.append('image_type', this.image_type);
                const { data: res } = await this.$http.post('/admin/articles/updateImage', formData);
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取资讯数据失败，请联系管理员!');
                }
                this.$message.success('【资讯图片】跟新成功!');
            },

            //上传前的检查判断
            beforeAvatarUpload(file) {
                const isJPG =
                    file.type === 'image/gif' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/jpeg' ||
                    file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error('仅支持gif,jpg,png格式的图片！');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!' + isLt2M);
                    console.log('isLt2M:' + file.size);
                }
                return isJPG && isLt2M;
            },
            // 删除当前图片前的确认
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            // 删除当前图片
            async handleRemove(file, fileList) {
                const { data: res } = await this.$http.post('/admin/scenics/updateImages', {
                    id: file.id
                });
                console.log(file, fileList);
            },
            handlePictureCardPreview(file) {
                this.picture_ImageUrl = file.url;
                this.picture_Visible = true;
            },

            //限制上传文件的数量
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 6 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            }
        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .searchPage {
        font-size: 14px;
        color: #606266;
        padding: 20px 0px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .wd200 {
        width: 200px;
    }

    .wd600 {
        width: 600px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }
</style>
